import React from 'react';

const SyntaxTreeDemoPage: React.FC = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold">Syntax Tree Demo Page</h1>
      <p className="mt-4 text-gray-600">This is a placeholder for the syntax tree demo page.</p>
    </div>
  );
};

export default SyntaxTreeDemoPage;
